import { createAction, props, union } from '@ngrx/store';

export const getTenantConfig = createAction('[System] GET_TENANT_CONFIG');

export const getTenantConfigSuccess = createAction(
  '[System] GET_TENANT_CONFIG_SUCCESS',
  props<{ tenantConfig: any }>()
);
export const getTenantConfigFail = createAction(
  '[System] GET_TENANT_CONFIG_FAIL',
  props<{ error: any }>()
);

const actions = union({
  getTenantConfig,
  getTenantConfigSuccess,
  getTenantConfigFail,
});

export type ActionsUnion = typeof actions;
